import React from 'react';
import parse, { domToReact } from 'html-react-parser';
import classNames from 'classnames';

import Link from '../Link';

const ns = `rte`;

/*
* parses & renders html string into dom nodes
* (WYSIWYG field type from Wordpress)
*/

const RenderStaticHTML = ({
	html, className, as, onLoad,
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[className]: className,
	});

	if (!html) return null;

	const CustomTag = as ? `${ as }` : null;

	const options = {
		replace: node => {
			const {
				name,
				children,
				attribs,
			} = node;

			// render Link component for a tags

			if (name === 'a') {
				const { class: className, ...rest } = attribs; // eslint-disable-line
				const props = { ...rest, className };
				/* eslint-disable */
				return (
					<Link {...props}>
						{domToReact(children, options)}
					</Link>
				);
				/* eslint-enable */
			}

			// render Link component for iframe tags

			if (name === 'iframe') {
				const props = Object.keys(attribs).reduce((obj, key) => {
					if (key === 'style' || key === 'frameborder') return {...obj};
					return {...obj, [key]: attribs[key]};
				}, {onLoad});

				/* eslint-disable */
				return (
					<iframe {...props}>
						{domToReact(children, options)}
					</iframe>
				);
				/* eslint-enable */
			}

			return false;
		},
	};

	const elements = parse(html, options);

	if (CustomTag) {
		return (
			<CustomTag>
				{elements}
			</CustomTag>
		);
	}

	return (
		<div className={rootClassnames}>
			{elements}
		</div>
	);
};

export default RenderStaticHTML;
